import { create } from 'zustand';

export interface ProfileSettingsModalStore {
  isOpen: boolean;
  onSuccessCallback?: () => void | Promise<void>;
  openModal: (onSuccess?: () => void | Promise<void>) => void;
  closeModal: () => void;
}

export const useProfileSettingsModalStore = create<ProfileSettingsModalStore>(
  (set) => ({
    isOpen: false,
    onSuccessCallback: undefined,

    openModal: (onSuccess) => {
      set({ isOpen: true, onSuccessCallback: onSuccess });
    },

    closeModal: () => {
      set({ isOpen: false, onSuccessCallback: undefined });
    },
  }),
);
